import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

const selectDialog = (state: RootState) => state.dialog;
function selectSelectedItemCartId(state: RootState) {
  return state.dialog.selectedItemCartId;
}

/**
 * HITL-1617 — which cart `selectedItemCartId` addresses. See
 * `redux/features/draftCart/cartScope.routing.ts` for why the write path needs
 * it and `selectWriteCartScope` for the flag-gated form components should read.
 */
function selectSelectedItemCartScope(state: RootState) {
  return state.dialog.selectedItemCartScope;
}

const selectDialogStep = createSelector(selectDialog, (dialog) => dialog.step);

const selectDialogSelectedModGroup = createSelector(
  selectDialog,
  (dialog) => dialog.selectedModGroup
);

const selectDialogHighlightedModifier = createSelector(
  selectDialog,
  (dialog) => dialog.highlightedModifier
);

const selectDialogClickedModifier = createSelector(
  selectDialog,
  (dialog) => dialog.clickedModifier
);

export {
  selectDialog,
  selectSelectedItemCartId,
  selectSelectedItemCartScope,
  selectDialogStep,
  selectDialogSelectedModGroup,
  selectDialogHighlightedModifier,
  selectDialogClickedModifier,
};
